import React from 'react';
import { CheckCircleBlue } from '@/components/Icons/CheckCircleBlue';

interface Props {
  items: string[];
}

export const PlanChecklistCard: React.FC<Props> = ({ items }) => (
  <ul className="flex flex-col gap-4 rounded-xl bg-info-surface p-4">
    {items.map((item) => (
      <li key={item} className="flex gap-2.5">
        <CheckCircleBlue className="mt-0.5 size-4 shrink-0 text-primary" />
        <span className="text-body-14 text-foreground">{item}</span>
      </li>
    ))}
  </ul>
);
